import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ImpersonationService } from '../services/impersonation.service';
import { environment } from '../../environments/environment';

export const impersonationInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiGesNormUri)) return next(req);

  const impersonation = inject(ImpersonationService);
  if (!impersonation.active) return next(req);

  return next(req.clone({
    setHeaders: { 'X-GesNorm-Impersonate': impersonation.email! }
  }));
};
